export const MICRO = 1e-6
export const NANO = 1e-9
